"use client";
import React, {useEffect, useRef, useState} from "react";
import Link from "next/link";
import qs from "qs";

// import classes from "./index.module.scss";
import { Product } from "../../../payload/payload-types";
import { fetchDocs } from "../../_api/fetchDocs";
import BrandProductsCard from "./BrandProductsCard";

import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import { Brand } from "../../../payload/payload-types";

import classes from "./index.module.scss";

export default function BrandProducts({ brand }) {
  const [brands, setBrands] = useState([]);
  const [loaded, setLoaded] = useState(false);
  //console.log("Brand Products", brand);
  let brandProducts: Product[] | null = null;
  const hasFetched = useRef(false);
  let brandId: Brand[] | null = null;
  if (brand !== undefined && brand.length > 0 && typeof brand === "object") {
    brandId = brand[0].id; //pass the slug id
  }

  const responsive = {
    superLargeDesktop: {
      // the naming can be any, depends on you.
      breakpoint: { max: 4000, min: 3000 },
      items: 5,
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 5,
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 3,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 2,
    },
  };

  useEffect(() => {
    async function getBrands() {
      try {
        //brandProducts = await fetchDocs<Product>("featuredproducts");
        const brands = []; //([]).map((cat) => (typeof cat === "object" ? cat?.id : cat)).join(",");
        const searchQuery = qs.stringify(
          {
            depth: 1,
            limit: 10,
            page: 1,
            sort: "-createdAt",
            where: {
              ...(brandId
                ? {
                    brands: {
                      in: [brandId],
                    },
                  }
                : {}),
            },
          },
          { encode: false }
        );
        if (brands.length == 0 && !loaded) {
          try {
            const req = await fetch(
              `${process.env.NEXT_PUBLIC_SERVER_URL}/api/products?${searchQuery}`
            );
            const json = await req.json();
            const { docs } = json as { docs: Product[] };
            brandProducts = docs;
            setBrands(docs);
            setLoaded(true);
            //console.log(docs);
          } catch (err) {
            console.log("error in request", err);
          }
        }
      } catch (error) {
        console.log("brand error", error);
        // when deploying this template on Payload Cloud, this page needs to build before the APIs are live
        // so swallow the error here and simply render the page with fallback data where necessary
        // in production you may want to redirect to a 404  page or at least log the error somewhere
        // console.error(error)
      }
    }
    if (!hasFetched.current) {
      getBrands();
      hasFetched.current = true; // Ensures function runs only once
    }
  }, [brands]);

  return (
    <section className={classes.container}>
      <div>
        <h3 className={classes.titleDescription}>Also from same brand</h3>
      </div>
      <div className={classes.list}>
        {brands &&
            brands.map((products, id) => {
              return (
                  <div key={id} className={classes.singleCarousel}>
                    <BrandProductsCard products={products}/>
                  </div>
              );
            })}
      </div>
    </section>
  );
}

//export default BrandProducts;
